export default {
    options: {
        slidesToShow: 1,
        slidesToScroll: 1,
        disabled: false
    },
    classes: {
        slider: 'o-slider',
        viewport: 'o-slider__viewport',
        track: 'o-slider__track',
        slide: 'o-slider__slide',
        slideClone: '0-slide__slide-clone'
    }
}
